import { SUPPORTED_LOCALES } from './init';
import { frLocale } from './locales/fr';
import * as I18nTypes from './types';

const initialState = {
    locales: SUPPORTED_LOCALES,
    ...frLocale,
};

const I18nReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case I18nTypes.SET_LOCALE:
            if (state.locales.indexOf(action.payload.locale) !== -1) {
                return {
                    ...state,
                    locale: action.payload.locale,
                    messages: action.payload.messages,
                };
            }
            return state;
        case I18nTypes.ADD_MESSAGES:
            return {
                ...state,
                messages: {
                    ...state.messages,
                    ...action.payload.messages,
                },
            };
        default:
            return state;
    }
};

export { I18nReducer };
